// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-breadcrumbs[data-v-2f005b1e]{padding:10px 12px 5px 12px}", ""]);
// Exports
module.exports = exports;
